"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    USER: 1,
    CHAR: 2,
    MASK: 3
};